import React, { useState, useContext } from 'react'
import styled from 'styled-components'
import get from 'lodash/get'
import { AppContext } from '../context/app'

import { Button } from '../components/common'
import { login } from '../utils/validation/schemes'

import { ToastContainer, toast, Slide } from 'react-toastify'
import { ERROR_TOAST } from '../components/common/toasts'
import Preloader from '../components/common/preloader'

import LogoSrc from '../assets/images/imaware-logo-color.svg'
import useNavigation from '../hooks/useNavigation'

const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 516px;
  margin: 0 auto;
  padding: 2rem;
`

const Logo = styled.img.attrs({
  src: LogoSrc
})`
  margin-bottom: 60px;
`

const Label = styled.label`
  font-family: 'Roboto';
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 1px;
  text-align: center;
  color: #24ab17;
  margin-bottom: 4rem;
  line-height: 1.2;
`

const Form = styled.form`
  width: 100%;
  padding: 1rem;
  margin: 0 auto;
`

const Input = styled.input`
  display: block;
  width: 100%;
  border: none;
  border-bottom: 1px solid #979797;
  margin-bottom: 60px;
  background: none;
  font-family: 'Roboto';
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.75;
  letter-spacing: 1.64px;
  color: #979797;
  ::placeholder {
    text-transform: uppercase;
  }
`

const Submit = styled(Button).attrs({
  type: 'submit'
})`
  display: block;
  margin: 0 auto;
`

const ForgotPassword = styled.a.attrs({
  href: 'https://imaware.okta.com/signin/forgot-password',
  target: 'noreferrer noopener'
})`
  text-align: center;
  color: rgb(151, 151, 151);
  letter-spacing: 0.05rem;
  font-size: 0.875rem;
  text-decoration: none;
  text-transform: uppercase;
  font-family: 'Proxima Nova', sans-serif;
`

const Login = () => {
  const { sessionId, startSession } = useContext(AppContext)
  const navigate = useNavigation()
  const [loading, setLoading] = useState(false)

  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')

  const handleSubmit = async e => {
    e.preventDefault()
    setLoading(true)
    const validation = login.validate({ username, password })
    if (get(validation, 'error')) {
      setLoading(false)
      return toast(get(validation, 'error.message'), ERROR_TOAST)
    }
    const successful = await startSession({ username, password })
    setLoading(false)
    if (!successful)
      toast('Please check your username and/or password.', ERROR_TOAST)
  }

  if (sessionId) {
    navigate('/requisitions')
    return <></>
  }

  return (
    <Column>
      <Logo />
      <Label>
        Log Into
        <br />
        The Portal
      </Label>
      <Form onSubmit={handleSubmit}>
        <Input
          placeholder="username"
          type="text"
          value={username}
          onChange={e => setUsername(get(e, 'target.value'))}
          disabled={loading}
        />
        <Input
          placeholder="password"
          type="password"
          value={password}
          onChange={e => setPassword(get(e, 'target.value'))}
          disabled={loading}
        />
        <br />
        {!loading && <Submit>log in</Submit>}
      </Form>
      <ForgotPassword>Forgot password?</ForgotPassword>
      <ToastContainer closeButton={false} transition={Slide} />
      {loading && <Preloader />}
    </Column>
  )
}

export default Login
